// LIBRERIE/IMPORTS
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const NotFoundProperty = () => {
    const { t } = useTranslation();

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px", maxWidth: "500px", margin: "40px auto" }}>

            <i style={{'fontSize':'10rem', 'color':'#252422'}}>
                <FontAwesomeIcon icon={faHouseCircleExclamation} />
            </i>

            <h2 style={{ color: "#020202", fontSize: "22px", marginBottom: "10px" }}>
                {t('propertyList.notFound.title')}
            </h2>

            <p style={{ color: "#020202", opacity: 0.7, fontSize: "16px", marginBottom: "20px" }}>
                {t('propertyList.notFound.suggestion')}
            </p>

            <Link
                className="btn btn-primary mt-4"
                title={t('navigation.homeLinkTitle') || 'Home'}
                to="/immobili"
            >
                <span>{t('propertyList.notFound.backToSearchLink')}</span>
            </Link>

        </div>
    )
}

export default NotFoundProperty;